// extracted by mini-css-extract-plugin
export default {"wrapper":"EventsConfigurationInfoCard_wrapper__rb2YP"};